const breakpoints = {
    Desktop: 990,
}

export default breakpoints
